import Vue from 'vue'
import {HTTP} from '@/utils/httpCommonUtil'
import {BallPulseLoader} from 'vue-loaders';
import VueSimpleSpinner from 'vue-simple-spinner'
import {getRestParamErrorMessage, getRestResponseErrorMessage} from '@/utils/serverErrorMessageUtil';
import flatPickr from 'vue-flatpickr-component';
import format from 'date-fns/format'
import {UserRoleEnum} from '@/enums/userRolesEnum'
import FacilityControl from '@/componentsReusable/FacilityControl.vue'
import UploadControl from '@/componentsReusable/UploadControl.vue'
import GenericModal from '@/componentsReusable/genericModal.vue'
import WarningModal from '@/componentsReusable/WarningModal.vue'
import ShiftEventHub from '@/components/shift/ShiftEventHub';
import LogisticsTaskCreationModal from "@/componentsReusable/LogisticsTaskCreationModal.vue";

export default Vue.component('provider-recommendations-card', {
  name: 'ProviderRecommendationsCard',
  props: {
    invoices: { type: Array }
  },
  data () {
    let emptyArray: Array<any> = [];
    return {
      cardExpanded: false,
      loadingInitialData: false,
      savingNewCredential: false,
      providerRecommendationsFromServer: emptyArray,
      providerRecommendationsFilteredAndChunked: emptyArray,
      providerRecommendations: emptyArray,
      isAuthorizedToAssign: false,
      showConfirmationModal: false,
      showLogisticsModal: false,
      savingWithoutLogisticTasks: true,
      selectedShifts: [] as any,
      showUnavailableConfirmationModal: false,
      pendingAssignProvider: null,
      providerToAssign: {} as any,
      noteChangeTimeout: setTimeout(function(){},0),
      providerSearchChangeTimeout: setTimeout(function(){},0),
      providerSearchText: '',
      providersToDisplayAtATime: 10,
      chunkIndex: 0,
    }
  },
  components: {
    flatPickr,
    BallPulseLoader,
    VueSimpleSpinner,
    FacilityControl,
    UploadControl,
    'generic-modal' : GenericModal,
    'warning-modal' : WarningModal,
    LogisticsTaskCreationModal,
  },
  beforeMount: function () {
    this.isAuthorizedToAssign = this.$store.getters['user/hasRole']([UserRoleEnum.MANAGER, UserRoleEnum.SCHEDULER, UserRoleEnum.RECRUITER, UserRoleEnum.CREDENTIALER, UserRoleEnum.TRAVEL_LOGISTICS]);
  },
  filters: {
    contactedUnavailable (provider: any) {
      if (!provider) { return ''; }
      if (provider.unavailable) { return 'Unavailable'; }
      if (provider.availabilityScore < 0) { return 'Unavailable'; }
      if (provider.contacted) { return 'Contacted'; }
    },
    cityStateMiles (provider: any) {
      if (!provider) { return ''; }
      let result = '';
      if (provider.city) { result += provider.city; }
      if (provider.state) { result += ', ' + provider.state; }
      if (!provider.distance) { result += ' - Miles'; }
      if (provider.distance) {
        if (result.length) { result += ' - '; }
        result += provider.distance + ' Miles';
      }
      return result;
    },
    dateformat (dateISO: string) {
      return format(dateISO, 'MM.DD.YYYY');
    },
    title (title: string ) {
      if (title && title.length) {
        return ' | ' + title;
      }
      return '';
    },
    phoneNumber (phoneNumber: string) {
      let formattedPhoneNumber = phoneNumber;
      if (phoneNumber && phoneNumber.length) {
        let phoneNumberArray = phoneNumber.match(/(\d)?(\d\d\d)?(\d\d\d)(\d\d\d\d)$/);
        if (!phoneNumberArray) { return formattedPhoneNumber; }
        formattedPhoneNumber = phoneNumberArray.length ? '' : formattedPhoneNumber;
        for (let i = 1; i < phoneNumberArray.length; i++) {
          if (phoneNumberArray[i]) {
            formattedPhoneNumber += phoneNumberArray[i] + '.';
          }
        }
        formattedPhoneNumber = formattedPhoneNumber.slice(0,formattedPhoneNumber.length - 1);
      } else {
        formattedPhoneNumber = 'NA';
      }
      return formattedPhoneNumber;
    },
    email (email: string ) {
      if (email && email.length) { return email; }
      return 'NA';
    },
  },
  methods: {
    expandCard () {
      this.cardExpanded = !this.cardExpanded;
      if (this.cardExpanded && this.invoices.length === 0) {
        this.getProviderRecommendations()
        this.providerSearchText = '';
      }
    },
    getProviderRecommendations () {
      let self = this
      let showLoadingSpinnerTimeout = setTimeout(function () {
        self.loadingInitialData = true;
      }, 0);
      HTTP.get('/api/shifts/' + this.$route.params.shiftId + '/provider-recommendations')
        .then(function (response) {
          clearTimeout(showLoadingSpinnerTimeout);
          self.loadingInitialData = false;
          if (!response.data || !response.data.data) {
            throw new Error("Error retrieving Provider Recommendations.");
          }
          let freshProviderRecommendations = response.data.data;
          freshProviderRecommendations.forEach( function (facilityCredential: any) {
            facilityCredential.isEditing = false;
            facilityCredential.updatingData = false;
            facilityCredential.searchText = facilityCredential.searchText.toLowerCase();
          });

          self.providerRecommendationsFromServer = freshProviderRecommendations;
          self.providerRecommendationsFilteredAndChunked = self.chunkArray(self.providerRecommendationsFromServer, self.providersToDisplayAtATime);
          self.chunkIndex = 0;
          self.providerRecommendations = (self.chunkIndex < self.providerRecommendationsFilteredAndChunked.length) ? self.providerRecommendationsFilteredAndChunked[self.chunkIndex] : [];
        })
        .catch(function () {
          console.log('response Error!');
          clearTimeout(showLoadingSpinnerTimeout);
          self.loadingInitialData = false;
          self.$notify({
            group: 'main',
            type: 'error',
            title: 'Error',
            text: 'An error occurred retrieving Provider Recommendations.'
          });
        })
    },
    chunkArray (arr: any[], chunkSize: number) {
      // arr = [0,1,2,3,4,5,6,7,8,9,10];
      // chunk = 2;
      let newArr = [];
      for (let i=0; i<arr.length; i+=chunkSize) {
        newArr.push(arr.slice(i,i+chunkSize));
      }
      return newArr;
      // console.log(newArr);
    },
    nextChunk () {
      if (this.chunkIndex < this.providerRecommendationsFilteredAndChunked.length) {
        this.chunkIndex ++;
        this.providerRecommendations = this.providerRecommendationsFilteredAndChunked[this.chunkIndex];
      }
    },
    previousChunk () {
      if (this.chunkIndex > 0) {
        this.chunkIndex --;
        this.providerRecommendations = this.providerRecommendationsFilteredAndChunked[this.chunkIndex];
      }
    },
    beginningChunk () {
      if (this.providerRecommendationsFilteredAndChunked.length) {
        this.chunkIndex = 0;
        this.providerRecommendations = this.providerRecommendationsFilteredAndChunked[this.chunkIndex];
      }
    },
    updateProviderRecommendationInfo (provider: any, contactedButtonChange: boolean) {
      let self = this
      provider.updatingData = true;
      // alert("contacted = " + provider.contacted);
      // alert("contactedDatetime = " + provider.contactedDatetime);
      // alert("note = " + provider.note);
      if (contactedButtonChange && provider.contacted) {
        if (provider.note == null || provider.note.trim === "") {
          provider.note = "";
        } else {
          provider.note = provider.note + "\n";
        }
        provider.contactedDatetime = new Date();
        provider.note = provider.note + "** Contacted on " + provider.contactedDatetime.toLocaleString();
      }
      HTTP.put('/api/shifts/' + this.$route.params.shiftId + '/provider-recommendations/' + provider.providerId, provider)
        .then(function (response) {
          provider.updatingData = false;
          // provider.isEditing = false;
          // self.getProviderRecommendations();
        })
        .catch(function (error) {
          provider.updatingData = false;

          // provider.facilityIdErrorMessage = getRestParamErrorMessage(error, 'facilityId');
          // provider.issuedDateErrorMessage = getRestParamErrorMessage(error, 'issuedDate');
          // provider.expirationDateErrorMessage = getRestParamErrorMessage(error, 'expirationDate');
          // provider.expirationNoticeDateErrorMessage = getRestParamErrorMessage(error, 'expirationNoticeDate');
          // // provider.isWelcomedErrorMessage = getRestParamErrorMessage(error, 'isWelcomed');
          // // provider.notesErrorMessage = getRestParamErrorMessage(error, 'notes');

          // if (
          //   !provider.facilityIdErrorMessage.length &&
          //   !provider.issuedDateErrorMessage.length &&
          //   !provider.expirationDateErrorMessage.length &&
          //   !provider.expirationNoticeDateErrorMessage.length) {
          let generalError = getRestResponseErrorMessage(error);
          self.$notify({
            group: 'main',
            type: 'error',
            title: 'Error Updating',
            text: generalError ? generalError : 'An error occurred updating provider recommendation.',
            // duration: 5000
          });
          // }

        })
    },
    cancelProviderModal () {
      this.pendingAssignProvider = null;
      this.showConfirmationModal = false;
    },
    confirmProviderWithLogistics () {
      this.showConfirmationModal = false;
      this.savingWithoutLogisticTasks = false;
      this.showLogisticsModal = true;
      this.assignConfirmed1(this.providerToAssign);
    },
    closeLogisticsConfirmationModal() {
      // show success message ONLY if 'No Logistics Needed' was clicked
      this.$notify({
        group: 'main',
        type: 'success',
        title: 'Success!',
        text: 'You successfully assigned ' + (this.providerToAssign as any).name + ' to this shift'
      });
      this.showLogisticsModal = false;
      this.pendingAssignProvider = null;
      // Broadcast, to whoever is listening, that a new a provider has been added or removed from the shift.
      ShiftEventHub.$emit('SHIFT_PROVIDER_CHANGE');
    },
    assignConfirmed1 (assignProvider: any) {
      if ((this.pendingAssignProvider as any).availabilityScore < 0 || (this.pendingAssignProvider as any).unavailable === true) {
        this.showConfirmationModal = false;
        this.showUnavailableConfirmationModal = true;
        // this.assignConfirmed2 (this.pendingAssignProvider);
      } else {
        this.showConfirmationModal = false;
        this.assignProvider(this.pendingAssignProvider, true);
      }
    },
    assignConfirmed2 (assignProvider: any) {
      this.showUnavailableConfirmationModal = false;
      this.assignProvider(this.pendingAssignProvider, true);
    },
    assignProvider (assignProvider: any, bypassDeleteConfirmation: boolean = false) {
      // To prevent a double submit
      if (assignProvider.updatingData) { console.log("returning."); return ; }

      if (!bypassDeleteConfirmation) {
        // Show Delete Confirmation Modal
        this.selectedShifts.push({
          shiftId: Number(this.$route.params.shiftId)
        })
        this.pendingAssignProvider = assignProvider;
        this.providerToAssign = assignProvider;
        this.providerToAssign.name = `${assignProvider.firstName} ${assignProvider.lastName} | ${assignProvider.title}`;
        this.showConfirmationModal = true;
        return;
      } else {
        this.pendingAssignProvider = null;
      }

      let self = this
      assignProvider.updatingData = true;
      HTTP.put('/api/shifts/' + this.$route.params.shiftId + '/providers/' + assignProvider.providerId)
        .then(function (response) {
          assignProvider.updatingData = false;
          assignProvider.isEditing = false;

          if (self.savingWithoutLogisticTasks) {
            // Broadcast, to whoever is listening, that a new a provider has been added or removed from the shift.
            ShiftEventHub.$emit('SHIFT_PROVIDER_CHANGE');
          }
          // self.getProviderRecommendations();
        })
        .catch(function (error) {
          assignProvider.updatingData = false;

          assignProvider.facilityIdErrorMessage = getRestParamErrorMessage(error, 'facilityId');
          assignProvider.issuedDateErrorMessage = getRestParamErrorMessage(error, 'issuedDate');
          assignProvider.expirationDateErrorMessage = getRestParamErrorMessage(error, 'expirationDate');
          assignProvider.expirationNoticeDateErrorMessage = getRestParamErrorMessage(error, 'expirationNoticeDate');
          // assignProvider.isWelcomedErrorMessage = getRestParamErrorMessage(error, 'isWelcomed');
          // assignProvider.notesErrorMessage = getRestParamErrorMessage(error, 'notes');

          if (
            !assignProvider.facilityIdErrorMessage.length &&
            !assignProvider.issuedDateErrorMessage.length &&
            !assignProvider.expirationDateErrorMessage.length &&
            !assignProvider.expirationNoticeDateErrorMessage.length) {
            let generalError = getRestResponseErrorMessage(error);
            self.$notify({
              group: 'main',
              type: 'error',
              title: 'Error Deleting',
              text: generalError ? generalError : 'An error occurred deleting credential.',
              // duration: 5000
            });
          }

        })
    },
    toggleEditProvider (provider: any) {
      let selectedId = provider.providerId;
      // Collapse any editing providers
      // Delete any existing "new" providers
      let indexesToDelete: any = [];
      this.providerRecommendations.forEach(function (item, index) {
        if (item.isNew) {
          indexesToDelete.push(index);
        }
        if (selectedId !== item.providerId) {
          item.isEditing = false;
        }
      });
      let self = this;
      indexesToDelete.forEach(function (indx: number) {
        self.providerRecommendations.splice(indx,1);
      })
      provider.isEditing = !provider.isEditing;
    },
    noteChange (provider: any) {
      let self = this;
      clearTimeout(this.noteChangeTimeout);
      this.noteChangeTimeout = setTimeout (function () {
        self.updateProviderRecommendationInfo(provider, false);
      }, 1000);
    },
    searchProvidersChange () {
      let self = this;
      self.providerRecommendationsFilteredAndChunked = [];
      let tempProviderSearchText = self.providerSearchText.toLowerCase();
      for (let i = 0; i < self.providerRecommendationsFromServer.length; i++) {
        if (self.providerRecommendationsFromServer[i].searchText.indexOf(tempProviderSearchText) > -1) {
          self.providerRecommendationsFilteredAndChunked.push(self.providerRecommendationsFromServer[i]);
        }
      }

      self.providerRecommendationsFilteredAndChunked = self.chunkArray(self.providerRecommendationsFilteredAndChunked, self.providersToDisplayAtATime);
      self.chunkIndex = 0;
      self.providerRecommendations = (self.chunkIndex < self.providerRecommendationsFilteredAndChunked.length) ? self.providerRecommendationsFilteredAndChunked[self.chunkIndex] : [];
    },
    onCopy (param: any) {
      this.$notify({
        group: 'main',
        type: 'success',
        title: 'Successfully Copied',
        text: 'Text ' + param.text + ' has been copied.',
      });
    },
    onError (param: any) {
      console.log('Error!');
      console.log(param);
      this.$notify({
        group: 'main',
        type: 'error',
        title: 'Error Copying',
        text: 'Something went wrong copying to your clipboard.',
      });
    },
    browseToInvoice (invoiceId: number) {
      window.open("/invoices/" + invoiceId, '_blank');
    },
    browseToProvider (providerId: number) {
      window.open("/providers/" + providerId, '_blank');
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/shift/cards/providerRecommendations/ProviderRecommendationsCard.ts